/**
 * Canonical list of project types supported by the estimator.
 *
 * This is a closed union today. New project types are added here first;
 * every other layer (config, pricing, UI) derives from this list rather
 * than re-declaring it, so adding a project type never requires touching
 * the calculation engine itself.
 */
export const PROJECT_TYPES = [
  "kitchen",
  "bathroom",
  "ensuite",
  "basement",
  "basement_suite",
  "living_room",
  "family_room",
  "dining_room",
  "bedroom",
  "primary_bedroom",
  "laundry_room",
  "mudroom",
  "home_office",
  "garage",
  "entryway_foyer",
  "hallway",
  "attic",
  "whole_home_renovation",
  "addition",
  "exterior",
  "deck_patio",
  "other_custom"
] as const;

export type ProjectType = (typeof PROJECT_TYPES)[number];

export function isProjectType(value: string): value is ProjectType {
  return (PROJECT_TYPES as readonly string[]).includes(value);
}

/** Human-readable labels, kept separate from the identifier so copy can change freely. */
export const PROJECT_TYPE_LABELS: Record<ProjectType, string> = {
  kitchen: "Kitchen",
  bathroom: "Bathroom",
  ensuite: "Ensuite",
  basement: "Basement",
  basement_suite: "Basement Suite",
  living_room: "Living Room",
  family_room: "Family Room",
  dining_room: "Dining Room",
  bedroom: "Bedroom",
  primary_bedroom: "Primary Bedroom",
  laundry_room: "Laundry Room",
  mudroom: "Mudroom",
  home_office: "Home Office",
  garage: "Garage",
  entryway_foyer: "Entryway / Foyer",
  hallway: "Hallway",
  attic: "Attic",
  whole_home_renovation: "Whole-Home Renovation",
  addition: "Addition",
  exterior: "Exterior",
  deck_patio: "Deck / Patio",
  other_custom: "Other / Custom Project"
};
